import { connect } from 'react-redux';
import Locale      from '../../../locale';

import Alert from './alert.jsx';

export default connect(
    // mapStateToProps
    state => ( {
        dismissLabel: Locale.getString( state, 'common.button.dismissAlertLabel' ),
    } ),
    // mapDispatchToProps
    {}
)( Alert );
